import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class TerraceGardens6PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.TERRACE_GARDENS6;
}

export default TerraceGardens6PoiTileEntity;
